var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEditSmall = function SvgEditSmall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "1p52v6evoa",
    d: "M0 0L15.841 0 15.841 15.822 0 15.822z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-865 -316) translate(865 316)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sbrkcomvfb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#1p52v6evoa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#15152A",
    d: "M14.423 2.634L2.805 14.251c-.203.088-.842.196-1.512.277.08-.669.187-1.308.275-1.51l11.62-11.616c.33-.33.906-.33 1.235 0 .339.338.339.891 0 1.232m.822-2.056c-.768-.77-2.111-.77-2.878 0L.707 12.234c-.118.119-.437.438-.647 2.898l-.06.69.69-.06c2.467-.218 2.779-.531 2.899-.648L15.245 3.458c.795-.795.795-2.088 0-2.88",
    mask: "url(#sbrkcomvfb)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditSmall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/editSmall.b1bedc24.svg";
export { ForwardRef as ReactComponent };